import { GameManager } from "@/app/lib/game-state/game-manager";
import { PyramidData } from "@/app/lib/system/puzzle-generator";
import { PyramidGameState } from "@/app/lib/game-state/pyramid-game-state";
import UI from "@/app/lib/ui/ui";

export async function fetchPyramidPuzzle(
    gameManager: GameManager,
    ui: UI
): Promise<boolean> {
    ui.setLoaded('pyramid', false);
    ui.hideOriginalWordHint();
    ui.wipeRefs();
    try{
        const res = await fetch(`/api/generate?puzzle=${gameManager.dictionaries.puzzle}&solutions=${gameManager.dictionaries.solutions}`);
        if (!res.ok) {
            throw new Error(`Error making fetch puzzle call -- ${res.status}: ${res.statusText}`)
        }
        const data = await res.json();
        const pyramidData: PyramidData = data.puzzle;
        gameManager.pyramid.update(
            pyramid => pyramid.buildPuzzle(pyramidData)
        )

        return true;
    } catch (error) {
        console.error('Failed to fetch puzzle', error);
        return false;
    }
};